import { GatsbyImage, IGatsbyImageData } from "gatsby-plugin-image";

import { Award } from "../../types";
import { AwardBadge } from "../award-badge";
import { Box } from "@vinomofo/components";
import { ProxyIcon } from "@vinomofo/icons";
import styled from "styled-components";

const StyledAwardBadge = styled(AwardBadge)`
  text-transform: capitalize;
  color: darkgrey;
  font-family: "GT Walsheim", sans-serif;
  font-size: 14px;
  margin: 8px 0px 0px;
`;

export interface AwardsBlockProps {
  awards: Array<Award>;
  badgeWidth: string;
}

const AwardIconComponent = ({
  label,
  image,
}: {
  label: string;
  image?: IGatsbyImageData;
}) => {
  if (image) {
    return <GatsbyImage image={image} alt={label} />;
  }

  // Extract point score from label (number between 90-100)
  // LC - this would be much better done by changing
  // all the types, and rendering either an Award OR a Rating.
  // but it's too much work for the night before go - live
  const points = label.match(/^(9[0-9]{1}|100)pts.+$/)?.[1];

  if (points) {
    return <ProxyIcon iconName={`points-${points}`} />;
  }

  return <ProxyIcon iconName="unavailable" />;
};

export const AwardsBlock = ({
  awards,
  badgeWidth,
}: AwardsBlockProps): JSX.Element => {
  return (
    <Box
      display="flex"
      flexWrap="wrap"
      justifyContent={["flex-start", "flex-start", "flex-start"]}
      gridGap={["0 20px", "0 98px", "0 40px"]}
    >
      {awards.map(({ label, image }, i) => {
        return (
          <AwardBadge
            key={i}
            display="flex"
            flexDirection="column"
            width={badgeWidth}
            size="64px"
            margin={"0 5px 15px"}
            label={<StyledAwardBadge>{label}</StyledAwardBadge>}
          >
            <AwardIconComponent label={label} image={image} />
          </AwardBadge>
        );
      })}
      {awards.length % 3 > 0 && <Box width={badgeWidth} mx="5px" />}
    </Box>
  );
};
